import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { DateField } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

export const DateFrom: React.FC<IFieldProps> = ({ baseName, readOnly }) => (
  <DateField
    name={`${baseName}.stringFeePropertyValues.${eFeePropertyNames.DateFrom}`}
    label={'Date From'}
    placeholder={'mm/dd/yyyy'}
    data-test-id={'fee-detail-date-from'}
    readOnly={readOnly}
    attachPortalInsideContainter
  />
);
